<template>
    <div class="container" @click="goFold">
        <cardHead title="圈舍概览" />
        <div class="center">
            <div class="round" >
                <span>7</span>
                <span>圈舍总数(个)</span>
            </div>
            <div class="round">
                <span>46666.67</span>
                <span>总面积(㎡)</span>
            </div>
        </div>
        <div class="footer">
            <div class="left f-c">
                <div class="group" style="margin-top: 0rem;">
                    <img src="../../../assets/yq/group.png" alt="">
                    <span>养殖圈：</span>
                    <span>5</span>
                </div>
                <div class="group">
                    <img src="../../../assets/yq/group.png" alt="">
                    <span>隔离圈：</span>
                    <span>1</span>
                </div>
                <!-- <div class="group">
                    <img src="../../../assets/yq/group.png" alt="">
                    <span>环境检测：</span>
                    <span>11</span>
                </div> -->
            </div>
            <div class="right f-c">
                <div class="group" style="margin-top: 0rem;">
                    <img src="../../../assets/yq/group.png" alt="">
                    <span>待产圈：</span>
                    <span>1</span>
                </div>
                <div class="group">
                    <img src="../../../assets/yq/group.png" alt="">
                    <span>饮水槽：</span>
                    <span>4</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cardHead from './cardHead.vue'
export default {

    props: {
        title: {
            type: String,
            default: '',
        },

    },
    components: {
        cardHead
    },
    data() {
        return {

        };
    },
    async created() {

    },

    methods: {

		goFold(){
			this.$router.push({ name: 'fold' })
		},

    },
};
</script>
<style lang="scss" scoped>
.container {
    width: 5rem;
    height: 100%;
    background: url('../../../assets/yq/rectangle1.png');
    background-size: 100% 100%;
	cursor: pointer;
	.round:hover,.group:hover{
		transform: scale3d(1.1, 1.1, 1.1);
	}
    .center {
        display: flex;
        margin-top: .44rem;
		
        .round {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 2.39rem;
            height: 1.38rem;
            background: url('../../../assets/yq/circle1.png');
            background-size: 100% 100%;
            font-weight: 400;
            color: #FFFFFF;

            span:nth-child(1) {
                font-size: 0.28rem;
                font-family: Impact-Regular, Impact;
            }

            span:nth-child(2) {
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                margin-top: .15rem;
            }
        }
    }

    .footer {
        margin-top: .38rem;
        display: flex;

        .f-c {
            display: flex;
            flex-direction: column;

            .group {
                display: flex;
                align-items: center;
                margin-top: .54rem;

                span {
                    margin-left: .13rem;
                    font-weight: 400;
                    color: #FFFFFF;
                }

                span:nth-child(2) {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                }

                span:nth-child(3) {
                    font-size: 0.3rem;
                    font-family: Impact-Regular, Impact;
                    margin-left: 0rem;
                }
            }
        }

        .left {
            margin-left: .3rem;
        }

        .right {
            margin-left: .7rem;
        }
    }

}
</style>